import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ProfileFotoPage from "./Components/ProfielFoto";
import { fetchpush, UpdatePush, UpdateProfile } from "./Reducers/actions";
import ProfielForm from "./Components/ProfielForm";
import NewPasswordPage from "./Components/NewPassword";
import { message } from "../../Reducers/loading/actions";
import { requestForToken } from "../../Auth/pushnotification";
import { updateuser } from "../../Reducers/auth/actions";
import SneaTabs from "../../Components/SneaTabs";
import moment from "moment";

const ProfilePage = ({ username, updateuser, fetchpush, UpdatePush, UpdateProfile, message }) => {
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [error, seterror] = useState(false);
  const [succes, setsucces] = useState(false);
  
  useEffect(() => {
    fetchpush().then((data) => {
      setLoadingProfile(true);
    });
  }, [fetchpush]);

  const submit = (vals) => {
    updateuser(vals).then((data) => {
      if (data.type === "PROFILE_ERROR") {
        message(3000, "danger", "Er is iets fout gegaan bij het opslaan");
      } else {
        message(3000, "success", "Je profiel is goed opgeslagen");
      }
    });
  };

  const activeerpush = () => {
    requestForToken().then((data) => {
      const existingPushClient = username.pushclient || [];
      const pushclient = [
        {
          push_token: data,
          agent: navigator.userAgent,
          datum: new Date(),
        },
        ...existingPushClient.filter((client) => client.push_token !== data),
      ];
      updateuser({pushclient: pushclient}).then((data) => {
        if (data.type === "PROFILE_ERROR") {
          message(3000, "danger", "Er is iets fout gegaan bij het opslaan");
        } else {
          message(3000, "success", "Push notificaties zijn geactiveerd");
        }
      });
    });
  };

  const getRoleLabel = (role) => {
    const roles = {
      'admin': { label: 'Administrator', class: 'bg-label-danger' },
      'manager': { label: 'Manager', class: 'bg-label-warning' },
      'medewerker': { label: 'Medewerker', class: 'bg-label-info' },
      'user': { label: 'Gebruiker', class: 'bg-label-secondary' }
    };
    return roles[role] || { label: 'Onbekend', class: 'bg-label-secondary' };
  };

  const tabs = [
    {
      id: 'personal',
      label: 'Persoonlijke Gegevens',
      icon: 'bx bx-user',
      content: (
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <i className="bx bx-user me-2"></i>
            <h5 className="mb-0">Persoonlijke Gegevens</h5>
          </div>
          <div className="card-body">
            {loadingProfile && <ProfielForm onSubmit={submit} />}
          </div>
        </div>
      )
    },
    {
      id: 'account',
      label: 'Account Instellingen',
      icon: 'bx bx-cog',
      content: (
        <div className="row">
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-bell me-2"></i>
                <h5 className="mb-0">Push Notificaties</h5>
              </div>
              <div className="card-body">
                <p className="text-muted mb-3">Ontvang real-time notificaties voor belangrijke updates.</p>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={activeerpush}
                >
                  <i className="bx bx-bell me-1"></i>
                  Activeer Push Notificaties
                </button>

                {username.pushclient && username.pushclient.length > 0 && (
                  <div className="mt-4">
                    <h6 className="text-muted">Geactiveerde Apparaten:</h6>
                    <div className="list-group list-group-flush">
                      {username.pushclient.map((client, index) => (
                        <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                          <div>
                            <div className="fw-semibold">
                              {client.agent ? client.agent.substring(0, 40) + '...' : 'Onbekend apparaat'}
                            </div>
                            <small className="text-muted">
                              Geactiveerd: {moment(client.datum).format('DD-MM-YYYY HH:mm')}
                            </small>
                          </div>
                          <span className="badge bg-label-success">Actief</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-slider-alt me-2"></i>
                <h5 className="mb-0">Voorkeuren</h5>
              </div>
              <div className="card-body">
                <div className="form-check mb-3">
                  <input className="form-check-input" type="checkbox" id="emailNotifications" defaultChecked />
                  <label className="form-check-label" htmlFor="emailNotifications">
                    E-mail notificaties ontvangen
                  </label>
                </div>
                <div className="form-check mb-3">
                  <input className="form-check-input" type="checkbox" id="marketingEmails" />
                  <label className="form-check-label" htmlFor="marketingEmails">
                    Marketing e-mails ontvangen
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="smsNotifications" />
                  <label className="form-check-label" htmlFor="smsNotifications">
                    SMS notificaties ontvangen
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'security',
      label: 'Beveiliging',
      icon: 'bx bx-shield-alt-2',
      content: (
        <div className="row">
          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-key me-2"></i>
                <h5 className="mb-0">Wachtwoord Wijzigen</h5>
              </div>
              <div className="card-body">
                <NewPasswordPage setsucces={setsucces} seterror={seterror} />
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-mobile-alt me-2"></i>
                <h5 className="mb-0">Twee-Factor Authenticatie</h5>
              </div>
              <div className="card-body">
                <p className="text-muted mb-3">
                  Extra beveiligingslaag voor je account door naast je wachtwoord ook een code van je telefoon te vereisen.
                </p>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <span className="text-muted">Status:</span>
                    <span className="badge bg-label-warning ms-2">Niet geactiveerd</span>
                  </div>
                  <button className="btn btn-outline-primary">
                    <i className="bx bx-shield-alt-2 me-1"></i>
                    Activeren
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex align-items-center">
                <i className="bx bx-laptop me-2"></i>
                <h5 className="mb-0">Actieve Sessies</h5>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center p-3 border rounded">
                  <div className="d-flex align-items-center">
                    <i className="bx bx-desktop fs-4 text-primary me-3"></i>
                    <div>
                      <div className="fw-semibold">Huidige sessie</div>
                      <small className="text-muted">
                        {navigator.userAgent.substring(0, 50)}...
                      </small>
                      <br />
                      <small className="text-success">
                        <i className="bx bx-circle fs-tiny me-1"></i>
                        Nu actief
                      </small>
                    </div>
                  </div>
                  <span className="badge bg-label-success">Huidige sessie</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'activity',
      label: 'Activiteit',
      icon: 'bx bx-time-five',
      content: (
        <div>
          <div className="row mb-4">
            <div className="col-xl-4 col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-md mx-auto mb-3">
                    <span className="avatar-initial rounded-circle bg-label-primary">
                      <i className="bx bx-log-in fs-4"></i>
                    </span>
                  </div>
                  <span className="text-heading fw-semibold d-block mb-1">Laatste Login</span>
                  <small className="text-muted">
                    {moment(username.lastLogin || username.createdAt).format('DD-MM-YYYY HH:mm')}
                  </small>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-md mx-auto mb-3">
                    <span className="avatar-initial rounded-circle bg-label-success">
                      <i className="bx bx-calendar fs-4"></i>
                    </span>
                  </div>
                  <span className="text-heading fw-semibold d-block mb-1">Account Leeftijd</span>
                  <small className="text-muted">
                    {moment(username.createdAt).fromNow()}
                  </small>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-md mx-auto mb-3">
                    <span className="avatar-initial rounded-circle bg-label-info">
                      <i className="bx bx-shield-alt-2 fs-4"></i>
                    </span>
                  </div>
                  <span className="text-heading fw-semibold d-block mb-1">Rol</span>
                  <small className="text-muted">
                    {getRoleLabel(username.role).label}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center">
              <i className="bx bx-history me-2"></i>
              <h5 className="mb-0">Recente Activiteit</h5>
            </div>
            <div className="card-body">
              <ul className="timeline">
                <li className="timeline-item timeline-item-transparent">
                  <span className="timeline-point timeline-point-success"></span>
                  <div className="timeline-event">
                    <div className="timeline-header mb-1">
                      <h6 className="mb-1">Account aangemaakt</h6>
                      <small className="text-muted">{moment(username.createdAt).format('DD-MM-YYYY HH:mm')}</small>
                    </div>
                    <p className="mb-0">Je account is succesvol aangemaakt en geactiveerd.</p>
                  </div>
                </li>
                <li className="timeline-item timeline-item-transparent">
                  <span className="timeline-point timeline-point-info"></span>
                  <div className="timeline-event">
                    <div className="timeline-header mb-1">
                      <h6 className="mb-1">Profiel bekeken</h6>
                      <small className="text-muted">Nu</small>
                    </div>
                    <p className="mb-0">Je hebt je profiel pagina bezocht.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="row">
      <div className="col-12">
        {/* Profile Header Card */}
        <div className="card mb-4">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="avatar-wrapper me-3">
                <ProfileFotoPage />
              </div>
              <div className="flex-grow-1">
                <h4 className="mb-1 text-heading">
                  {username.voornaam} {username.achternaam}
                  <span className={`badge ms-2 ${getRoleLabel(username.role).class}`}>
                    {getRoleLabel(username.role).label}
                  </span>
                </h4>
                <p className="mb-2">
                  <i className="bx bx-envelope me-2"></i>
                  {username.email}
                </p>
                {username.bedrijf && (
                  <p className="mb-0 text-muted">
                    <i className="bx bx-buildings me-2"></i>
                    {username.bedrijf.naam}
                  </p>
                )}
              </div>
              <div className="text-end">
                <small className="text-muted d-block">Lid sinds</small>
                <strong className="text-heading">{moment(username.createdAt).format('DD-MM-YYYY')}</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Content Tabs */}
        <SneaTabs
          tabs={tabs}
          defaultActiveTab={activeTab}
          variant="default"
          onTabChange={(tabId, index) => setActiveTab(index)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    username: state.auth.user,
    push: state.push,
  };
};

export default connect(mapStateToProps, { fetchpush, UpdatePush, UpdateProfile, message, updateuser })(ProfilePage);
